import React from 'react'

const ProjectJobFilter = () => {
    return (
        <div className="col-lg-3 col-md-3 mb-4 mb-md-0">
            <div className="ct_filter_btn ">
                <button className="ct_outline_grey ct_yellow_btn ct_h_35 d-flex align-items-center gap-2">
                    Filter
                    <img src="../assets/img/octicon_filter-16.png" alt="" />
                </button>
            </div>
            <div className="ct_filter_sidebar ct_custom_scroll">
                <div className="ct_close_filter d-block d-lg-none">
                    <i className="fa-solid fa-xmark"></i>
                </div>
                <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3 ">Status</h5>
                    <ul>
                        <li>
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    All
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Pending
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Active (Jobs only)
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Approved
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Rejected
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Expired (Jobs only)
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3 ">Submitter</h5>
                    <ul>
                        <li>
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Founder
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Enterprice
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Admin
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
            
                {/* <div className="mt-4">
                    <h5 className="ct_fs_16 mb-3 ">Category</h5>
                    <ul>
                        <li>
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    EdTech
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    HealthTech
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Design
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Project
                                </label>
                            </div>
                        </li>
                        <li className="mt-2">
                            <div className="form-check ct_custom_check2 ct_custom_check_grey d-flex align-items-center gap-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    id="flexCheckDefault"
                                />
                                <label for="" className="ct_text_clr_757886">
                                    Devlopment
                                </label>
                            </div>
                        </li>
                    </ul>
                </div> */}
            </div>
        </div>
    )
}

export default ProjectJobFilter